// Purpose-built at 32px: crisp horns, a three-point crown and a squared bull muzzle.
// No raster assets, SVG filter resources or duplicate SVG IDs in the afterimages.
export const BullGlyph = ({ testId }) => (
  <svg viewBox="0 0 32 32" width="32" height="32" fill="none" aria-hidden="true" focusable="false" data-testid={testId}>
    <g stroke="currentColor" strokeWidth="1.2" strokeLinejoin="bevel" strokeLinecap="round">
      <path d="M10 7 9 2.8l4.5 2L16 1l2.5 3.8 4.5-2-1 4.2Z" fill="rgba(4,9,7,.9)" />
      <path d="M10.5 12C6.5 12 4.8 9.8 4.2 7L2 9.5C1.6 13.5 5 16.2 10 16.2M21.5 12c4 0 5.7-2.2 6.3-5L30 9.5c.4 4-3 6.7-8 6.7" fill="rgba(4,9,7,.86)" />
      <path d="m10 13 3-3h6l3 3-.8 8.2-2 3.4-.8 4.4h-4.8l-.8-4.4-2-3.4Z" fill="rgba(4,9,7,.9)" />
      <path d="m11.8 16.4 2.8 1.2-1.8 1.1Zm8.4 0-2.8 1.2 1.8 1.1Z" fill="currentColor" strokeWidth=".5" />
      <path d="m13.1 24.7 2.9-1 2.9 1M14.8 27h2.4" strokeWidth=".85" />
    </g>
    <path d="M16 11.5v9M11 8.5h10m-9.6 11 1.1 3m8.1-3-1.1 3" stroke="#C6DCD0" strokeOpacity=".5" strokeWidth=".7" />
  </svg>
);

export const TargetReticle = () => (
  <svg className="bt-reticle" viewBox="0 0 48 48" aria-hidden="true" focusable="false" data-testid="bull-target-reticle">
    <circle cx="24" cy="24" r="20.25" fill="none" stroke="#04110A" strokeWidth="2.8" />
    <path d="M24 .5v4M24 43.5v4M.5 24h4M43.5 24h4" stroke="#04110A" strokeWidth="3" />
    <circle cx="24" cy="24" r="20.25" fill="none" stroke="currentColor" strokeWidth=".8" />
    <path d="M24 .5v4M24 43.5v4M.5 24h4M43.5 24h4" stroke="currentColor" strokeWidth="1.25" />
    <path d="M20.5 .75h7M20.5 47.25h7M.75 20.5v7M47.25 20.5v7" stroke="currentColor" strokeOpacity=".48" strokeWidth=".7" />
  </svg>
);